import { decimalToMSBLSB } from '../../ReusableComponents/ByteTransfer/utils'
import { computeAiSettingsByte } from '../../Simulate/BytesGeneration/aiSettingsByte'

//all app ai mode prefix bytes
const aiBytesPrefix = {
    colorBytesPrefix: [
        'A'.charCodeAt(0),
        'I'.charCodeAt(0),
        6,
        'C'.charCodeAt(0),
    ],
    faceBytesPrefix: [
        'A'.charCodeAt(0),
        'I'.charCodeAt(0),
        0, // index 2 show the length of bytes
        'F'.charCodeAt(0),
    ],
    wakeBytesPrefix: [
        'A'.charCodeAt(0),
        'I'.charCodeAt(0),
        0, // index 2 show the length of bytes
        'W'.charCodeAt(0),
    ],
    speechBytesPrefix: [
        'A'.charCodeAt(0),
        'I'.charCodeAt(0),
        0, // index 2 show the length of bytes
        'F'.charCodeAt(0),
    ],
}

// generate the  CRC(Cyclic Redundancy Check)
const crc_create0 = (buf) => {
    let crc
    let temp = 0
    for (let i = 0; i < buf.length; i++) {
        console.log('GGGGGG', buf[i])
        temp += buf[i]
    }
    temp = temp & 0xff
    crc = ~temp
    return crc & 0xff
}
const crc_create = (buf) => {
    let crc = 0x00

    for (let i = 0; i < buf.length; i++) {
        // console.log('GGGGGG', buf[i])
        crc ^= buf[i] // XOR the CRC with the current byte

        // Process each bit in the current byte
        for (let j = 0; j < 8; j++) {
            if (crc & 0x80) {
                // If the MSB is set, XOR with the polynomial 0x07
                crc = (crc << 1) ^ 0x07
            } else {
                // Otherwise, just shift the CRC left
                crc = crc << 1
            }

            // Ensure CRC remains an 8-bit value
            crc &= 0xff
        }
    }
    // console.log('VVVVVVVVV', crc)
    return crc
}

// Parse an AI firmware string such as "AI1.0.3.0" into [1, 0, 3, 0].
const parseAiVersion = (versionString) => {
    const match = String(versionString || '').match(
        /(\d+)\.(\d+)\.(\d+)\.(\d+)/
    )
    return match ? match.slice(1, 5).map(Number) : null
}

// true when the AI firmware version is known and >= minVersion ([a, b, c, d]).
const isAiVersionAtLeast = (versionString, minVersion) => {
    const version = parseAiVersion(versionString)
    if (!version) return false
    for (let i = 0; i < 4; i++) {
        if (version[i] > minVersion[i]) return true
        if (version[i] < minVersion[i]) return false
    }
    return true
}

// From AI1.0.3.0 the hardware enroll button is gone and the face name packet
// (0x46) itself enrolls the face, so its reply is the final result.
// The ports must first be enabled with 0x58 (SETTING 0x02 for face training).
const AI_PORTS_SETTING_FACE_TRAIN = 0x02
const FACE_CAPTURE_TRIGGER_MIN_AI_VERSION = [1, 0, 3, 0]

const appAiBytesGeneration = (byteType, ele, ind) => {
    try {
        let bytes = ['A'.charCodeAt(0), 'I'.charCodeAt(0)]
        let crc = ''

        switch (byteType) {
            case 'aiVersionByte': {
                bytes.push(2, 0x3f)
                crc = crc_create([2, 0x3f])
                break
            }
            case 'faceByte': {
                // bytes = [...aiBytesPrefix.faceBytesPrefix]
                let length = ele.faceName.length + 3
                bytes.push(length, 'F'.charCodeAt(0))

                // bytes.push(ind + 1) //face id
                let nameAsci = ele.faceName
                    .split('')
                    .map((item) => item.charCodeAt(0))
                bytes = [...bytes, ind, ...nameAsci]

                crc = crc_create([length, 'F'.charCodeAt(0), ind, ...nameAsci])

                break
            }
            case 'enableAiPortsByte': {
                // AI >= 1.0.3.0: ele is the ports SETTING byte
                bytes.push(3, 0x58, ele)
                crc = crc_create([3, 0x58, ele])
                break
            }
            case 'trainFaceTriggerByte': {
                bytes.push(2, 0xfe)
                crc = crc_create([2, 0xfe])

                break
            }
            case 'deleteFaceByte': {
                bytes.push(3, 0xfd, ele)
                crc = crc_create([3, 0xfd, ele])
                break
            }
            case 'stopTrainByte': {
                bytes.push(2, 0x00)
                crc = crc_create([2, 0x00])
                break
            }
            case 'startColorByte': {
                bytes.push(2, 0xc0)
                crc = crc_create([2, 0xc0])
                break
            }
            case 'bondingBoxColorByte': {
                ele = parseInt(ele)
                bytes.push(3, 0xc2, ele)
                crc = crc_create([3, 0xc2, ele])
                break
            }
            case 'thresholdColorByte': {
                ele = parseInt(ele)
                bytes.push(3, 0xc3, ele)
                crc = crc_create([3, 0xc3, ele])
                break
            }
            case 'colorByte': {
                bytes.push(3, 0xc1, ele)
                crc = crc_create([3, 0xc1, ele])
                break
            }
            case 'deleteColorByte': {
                bytes.push(3, 0xc4, ele)
                crc = crc_create([3, 0xc4, ele])
                break
            }
            case 'wakeByte': {
                let length = ele.length + 2
                bytes.push(length, 'W'.charCodeAt(0))

                let wakeAsci = ele.split('').map((item) => item.charCodeAt(0))
                bytes = [...bytes, ...wakeAsci]

                crc = crc_create([length, 'W'.charCodeAt(0), ...wakeAsci])
                break
            }
            case 'speechByte': {
                let length = ele.value.length + 3
                bytes.push(length, 'V'.charCodeAt(0))
                bytes.push(ind + 1) //speech id

                let speechAsci = ele.value
                    .split('')
                    .map((item) => item.charCodeAt(0))
                bytes = [...bytes, ...speechAsci]

                crc = crc_create([
                    length,
                    'V'.charCodeAt(0),
                    ind + 1,
                    ...speechAsci,
                ])
                break
            }
            case 'cleanByte': {
                ///change bytes cllear for voice
                let length = 3
                let commend = '0'
                if (ele == 'color') {
                    commend = 'C'
                } else if (ele == 'face') {
                    commend = 'F'
                } else if (ele == 'speech') {
                    commend = 'S'
                } else {
                    commend = 'C'
                }

                bytes.push(length, 'D'.charCodeAt(0), commend.charCodeAt(0))

                crc = crc_create([
                    length,
                    'D'.charCodeAt(0),
                    commend.charCodeAt(0),
                ])
                break
            }
            case 'getAudioByte': {
                //change th bytes
                bytes.push(2, 0x1c)
                crc = crc_create([2, 0x1c])
                break
            }
            case 'getFaceListByte': {
                bytes.push(2, 0x1f)
                crc = crc_create([2, 0x1f])
                break
            }
            case 'getColorListByte': {
                bytes.push(2, 0xcc)
                crc = crc_create([2, 0xcc])
                break
            }
            case 'getSpeechListByte': {
                bytes.push(2, 0x15)
                crc = crc_create([2, 0x15])
                break
            }
            case 'scanWifiByte': {
                bytes.push(2, 0x2e)
                crc = crc_create([2, 0x2e])
                break
            }
            case 'setWifiSSIDByte': {
                let length = ele.length + 2

                let ssidAsci = ele.split('').map((item) => item.charCodeAt(0))

                bytes = [...bytes, length, 0x3e, ...ssidAsci]
                crc = crc_create([length, 0x3e, ...ssidAsci])
                break
            }
            case 'setWifiPasswordByte': {
                let length = ele.length + 2

                let passwordAsci = ele
                    .split('')
                    .map((item) => item.charCodeAt(0))

                bytes = [...bytes, length, 0x4e, ...passwordAsci]
                crc = crc_create([length, 0x4e, ...passwordAsci])
                break
            }
            case 'wifiConnectByte': {
                bytes.push(2, 0x5e)
                crc = crc_create([2, 0x5e])
                break
            }
            case 'checkWifiConnectByte': {
                bytes.push(2, 0x7e)
                crc = crc_create([2, 0x7e])
                break
            }
            case 'wifiDisconnectByte': {
                bytes.push(2, 0x6e)
                crc = crc_create([2, 0x6e])
                break
            }
            case 'httpJWTByte': {
                bytes[1] = 'L'.charCodeAt('0')
                let length = ele.length + 2

                let msbLsb = decimalToMSBLSB(length)

                let jwtAsci = ele.split('').map((item) => item.charCodeAt(0))

                bytes = [...bytes, ...msbLsb, 0x84, ...jwtAsci]
                crc = crc_create([...msbLsb, 0x84, ...jwtAsci])
                break
            }
            case 'httpHostByte': {
                let host = 'https://iot.plode.org'
                let length = host.length + 2

                let hostAsci = host.split('').map((item) => item.charCodeAt(0))

                bytes = [...bytes, length, 0x82, ...hostAsci]
                crc = crc_create([length, 0x82, ...hostAsci])
                break
            }
            case 'httpPathByte': {
                let path = '/api/v1/services/1'
                let length = path.length + 2

                let passwordAsci = path
                    .split('')
                    .map((item) => item.charCodeAt(0))

                bytes = [...bytes, length, 0x83, ...passwordAsci]
                crc = crc_create([length, 0x83, ...passwordAsci])
                break
            }
            case 'startChatByte': {
                bytes.push(2, 0xcb)
                crc = crc_create([2, 0xcb])
                break
            }
            // case 'stopTrainByte': {
            //     bytes.push(2, 0x00)
            //     crc = crc_create([2, 0x00])
            //     break
            // }
            case 'stopProgramByte': {
                bytes.push(2, 0xa0)
                crc = crc_create([2, 0xa0])
                break
            }
            case 'personaUpdateByte': {
                let length = ele.length + 2

                bytes = [...bytes, length, 'S'.charCodeAt(0), ...ele]
                crc = crc_create([length, 'S'.charCodeAt(0), ...ele])
                break
            }
        }

        bytes.push(crc, 0xff, 0xf9)
        console.log('bytes', bytes)
        return bytes
    } catch (e) {
        console.log('ERROR', e)
        return [
            'R'.charCodeAt(0),
            'E'.charCodeAt(0),
            'S'.charCodeAt(0),
            'T'.charCodeAt(0),
        ]
    }
}

const getEnableAiItems = (hexProgram, aiItems) => {
    try {
        for (let i in hexProgram) {
            let programNode = hexProgram[i]
            if (programNode.type === 'hardware') {
                let nodeState = programNode.state
                Object.keys(nodeState).map((key) => {
                    if (
                        nodeState[key] &&
                        key.includes('ai') &&
                        key.includes('assign')
                    ) {
                        let newKey = key.replace('assign', '')
                        newKey = newKey.replace('A1', '')
                        aiItems[newKey] = true
                    }
                })
            }

            // every node type the code generator reads a sensor source from
            if (
                ['sensor', 'condition', 'if', 'else', 'variable'].includes(
                    programNode.type
                )
            ) {
                let nodeState = programNode.state
                if (nodeState) {
                    if (
                        [
                            'ai_motion',
                            'ai_color_recognition',
                            'ai_face_detection',
                            'ai_face_recognition',
                            'ai_mic',
                            'ai_lidar',
                            'ai_light',
                            'ai_proximity',
                        ].includes(nodeState.source)
                    ) {
                        aiItems[nodeState.source] = true
                    }

                    if (
                        nodeState.source?.includes('ai_face_tracking_X') ||
                        nodeState.source?.includes('ai_face_tracking_Y')
                    ) {
                        aiItems.ai_face_tracking = true
                    }
                    if (
                        nodeState.source?.includes('ai_color_tracking_X') ||
                        nodeState.source?.includes('ai_color_tracking_Y')
                    ) {
                        aiItems.ai_color_tracking = true
                    }
                }
            }

            if (programNode?.subprogram && programNode?.subprogram.length > 0) {
                getEnableAiItems(programNode?.subprogram, aiItems)
            }
        }
    } catch (e) {
        console.log('ERROR', e)
    }
}

// AI Settings Byte [ASB] bit layout (AI v0.2 byte structure):
//   bit0 LED enable | bit1 camera face | bit1+bit2 camera color |
//   bit2 camera motion | bit3 speech enable | bit4 audio enable |
//   bit5 SW enable (no source wired up yet) | bit6 lidar/proximity (STK3310)
const ASB_BIT = {
    LED: 1 << 0,
    CAMERA_FACE: 1 << 1,
    CAMERA_MOTION: 1 << 2,
    SPEECH: 1 << 3,
    AUDIO: 1 << 4,
    SW: 1 << 5,
    LIDAR: 1 << 6,
}
ASB_BIT.CAMERA_COLOR = ASB_BIT.CAMERA_FACE | ASB_BIT.CAMERA_MOTION

//generat the peeCeeTed Ai Data in hex programming
const generateAidata = (hexProgram) => {
    let aiItems = {
        ai_motion: false,
        ai_color_recognition: false,
        ai_color_tracking: false,
        ai_face_detection: false,
        ai_face_recognition: false,
        ai_face_tracking: false,
        ai_mic: false,
        ai_lidar: false,
        ai_LED: false,
        ai_audio: false,

        ai_proximity: false,
        ai_light: false,
    }
    getEnableAiItems(hexProgram, aiItems)

    let settingsByte = 0
    if (aiItems.ai_LED) settingsByte |= ASB_BIT.LED
    if (aiItems.ai_color_recognition || aiItems.ai_color_tracking) {
        settingsByte |= ASB_BIT.CAMERA_COLOR
    } else {
        if (
            aiItems.ai_face_detection ||
            aiItems.ai_face_recognition ||
            aiItems.ai_face_tracking
        ) {
            settingsByte |= ASB_BIT.CAMERA_FACE
        }
        if (aiItems.ai_motion) settingsByte |= ASB_BIT.CAMERA_MOTION
    }
    if (aiItems.ai_mic) settingsByte |= ASB_BIT.SPEECH
    if (aiItems.ai_audio) settingsByte |= ASB_BIT.AUDIO
    // ai_light has no ASB bit (not part of the AI v0.2 accessory list) and is
    // intentionally not encoded here.
    if (aiItems.ai_lidar || aiItems.ai_proximity) settingsByte |= ASB_BIT.LIDAR

    // Byte 8 is a fixed 'X' marker, byte 9 is the settings byte — bytes 4-7
    // stay reserved/zero (per-feature port programming is sent separately).
    let bytes = ['A'.charCodeAt(0), 'I'.charCodeAt(0), 8, 'S'.charCodeAt(0)]
    bytes.push(0, 0, 0, 0, 'X'.charCodeAt(0), settingsByte)

    let spliceByte = [...bytes].splice(2, 8)
    let crc = crc_create(spliceByte)

    bytes.push(crc, 0xff, 0xf9)
    console.log('bytes', bytes)

    return bytes
}

//generat ai REST data
// AI >= 1.0.3.0 needs the SETTING byte: A I 03 58 SETTING CRC FF F9
const generateAiresetdata = (program, aiVersion) => {
    if (
        parseAiVersion(aiVersion) &&
        !isAiVersionAtLeast(aiVersion, [1, 0, 3, 0])
    ) {
        let data = ['A'.charCodeAt(0), 'I'.charCodeAt(0), 2, 'X'.charCodeAt(0)]
        let crc = crc_create([2, 'X'.charCodeAt(0)])
        data.push(crc, 0xff, 0xf9)

        return data
    }
    let aiItems = {}
    getEnableAiItems(program, aiItems)
    return appAiBytesGeneration(
        'enableAiPortsByte',
        computeAiSettingsByte(aiItems)
    )
}

//fetch the AI audioFiles
const fetchAudioList = async (worker) => {
    try {
        let getAudioBytes = appAiBytesGeneration('getAudioByte')

        worker.postMessage({
            type: 'aiFetchAudioWriteArray',
            value: getAudioBytes,
        })
    } catch (e) {
        console.log('ERROR', e)
    }
}

//fetch the AI FaceList
const fetchFaceList = async (worker) => {
    try {
        let getFaceListByte = appAiBytesGeneration('getFaceListByte')

        worker.postMessage({
            type: 'aiFetchAudioWriteArray',
            value: getFaceListByte,
        })
    } catch (e) {
        console.log('ERROR', e)
    }
}

//fetch the AI Speech List
const fetchSpeechList = async (worker) => {
    try {
        let getSpeechListByte = appAiBytesGeneration('getSpeechListByte')

        worker.postMessage({
            type: 'aiFetchAudioWriteArray',
            value: getSpeechListByte,
        })
    } catch (e) {
        console.log('ERROR', e)
    }
}

export {
    appAiBytesGeneration,
    parseAiVersion,
    isAiVersionAtLeast,
    FACE_CAPTURE_TRIGGER_MIN_AI_VERSION,
    AI_PORTS_SETTING_FACE_TRAIN,
    crc_create,
    generateAidata,
    generateAiresetdata,
    getEnableAiItems,
    fetchAudioList,
    fetchFaceList,
    fetchSpeechList,
}
